<template>
    <v-app-bar app dark>
        <v-row align="center">
            <v-col cols="auto">
                <v-toolbar-title color="white">{{title}}</v-toolbar-title>
            </v-col>

            <v-spacer></v-spacer>

            <v-col v-if="actions.length > 0" cols="auto">
                <v-tooltip
                        v-for="(action, index) in actions"
                        bottom
                        :disabled="!action.hasOwnProperty('title') || !action.hasOwnProperty('icon')"
                        v-bind:key="index"

                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                                v-on="on"
                                :fab="action.hasOwnProperty('icon')"
                                :rounded="!action.hasOwnProperty('icon')"
                                dark
                                :small="action.hasOwnProperty('icon')"
                                :color="action.hasOwnProperty('color') ? action.color : 'grey darken-2'"
                                :to="action.hasOwnProperty( 'to' ) ? action.to : null"
                                @click="action.hasOwnProperty( 'click' ) ? action.click() : null"
                                :class="index > 0 ? 'ml-2' : ''"
                        >
                            <v-icon v-if="action.hasOwnProperty('icon')" dark>{{action.icon}}</v-icon>
                            <span v-else>{{action.title}}</span>

                        </v-btn>
                    </template>
                    <span v-if="action.hasOwnProperty('title')">{{action.title}}</span>
                </v-tooltip>
            </v-col>
        </v-row>
    </v-app-bar>
</template>
<script>
    export default {
        name: "AppBar",
        props: {
            title: {
                type: String,
                default: 'AppBarDefault'
            },
            actions:{
                type: Array,
                default: () => []
            }
        },
    }
</script>